export default class JPRouteHelper {

    static printStep(params) {
        const args = Array.prototype.slice.call(params, 0, -1);
        const stepIndex = args[0];
        const stepsLength = args[1];
        const elementsBeforeDots = args[2];
        return stepIndex <= elementsBeforeDots || stepIndex === stepsLength - 1;
    }

    static printDots(params) {
        const args = Array.prototype.slice.call(params, 0, -1);
        const stepIndex = args[0];
        const stepsLength = args[1];
        const elementsBeforeDots = args[2];
        return stepIndex === elementsBeforeDots && stepsLength !== elementsBeforeDots + 1;
    }
}



// WEBPACK FOOTER //
// ./src/helpers/JPRouteHelper.js